module.exports = __webpack_public_path__ + "static/media/logo-icon-dark-1.68abe3cd.svg";